<!-- ログアウトを実行するボタン -->
<template>
  <b-button :size="propSize" :variant="propVariant" :class="propClass" @click="clickLogout()">ログアウト</b-button>
</template>
<script>
/* eslint-disable */

import config from "../../const/config";

export default {
  name: "BtnLogout",
  props: {
    value: {},
    propSize: { type: String, default: "sm" },
    propVariant: { type: String, default: "danger" },
    propClass: { type: String, default: "" },
  },
  computed: {},
  data: function () {
    return {};
  },
  methods: {
    clickLogout: function () {
      this.$confirm("ログアウトしますか？", "", {
        confirmButtonText: "OK",
        cancelButtonText: "キャンセル",
      }).then(() => {
        this.logout();
      });
    },
    logout: function () {
      this.postData(config.URL.LOGOUT)
        .then((respons) => {
          console.log(respons);
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.$router.push(config.PAGES.LOGIN);
        });
    },
  },
};
</script>

<style></style>
